import { render, staticRenderFns } from "./ProfesorMaterial.vue?vue&type=template&id=6465b914&class=mainMaterial&"
import script from "./ProfesorMaterial.vue?vue&type=script&lang=js&"
export * from "./ProfesorMaterial.vue?vue&type=script&lang=js&"
import style0 from "./ProfesorMaterial.vue?vue&type=style&index=0&id=6465b914&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports